// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1y-0";
export var spinnerContainer = "_1y-1";